(function (upp, $UPP) {
    'use strict';

    var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE + "users";

    upp.service('restoreService', ['appi', '$q',
            function (appi, $q) {
                /**
                 * Creates a new password change request and sends an email to the user so he/she can restore
                 * his/her password.
                 * @param {String} email
                 * @returns {Promise}
                 * @private
                 */
                var _restorePassword = function (email) {
                    var deferred = $q.defer();

                    appi.http.post(URL_API_REST_SERVER + '/password/restore/email', {
                        email: email
                    })
                        .then(function () {
                            deferred.resolve(true);
                        }, function (err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                };

                /**
                 * Changes the user password
                 * @param {String} password New password
                 * @param {String} token The token received from the email
                 * @returns {Promise}
                 * @private
                 */
                var _changePassword = function (password, token) {
                    var deferred = $q.defer();

                    appi.http.post(URL_API_REST_SERVER + '/password/change', {
                        password: password,
                        token: token
                    }).then(function () {
                        deferred.resolve(true);
                    }, function (err) {
                        deferred.resolve(err);
                    });

                    return deferred.promise;
                };

                return {
                    restorePassword: _restorePassword,
                    changePassword: _changePassword
                }
            }]
    );

}(upp, $UPP));


// WEBPACK FOOTER //
// ./src/app/plugins/login/services/restore-service.js